import axios from 'axios';

export const PROJECTS_CACHE_KEY = 'mimgs_v3';
export const PROJECTS_API = 'https://renderplayz.com/api/interactive_api.json';

export function slugifyProject(name = '') {
    return name
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
}

export function getProjectId(project = {}) {
    return project.id || slugifyProject(project.name);
}

export function readCachedProjects() {
    try {
        const raw = window.sessionStorage.getItem(PROJECTS_CACHE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export function cacheProjects(list) {
    try {
        window.sessionStorage.setItem(PROJECTS_CACHE_KEY, JSON.stringify(list));
    } catch (error) {
        console.log(error);
    }
}

export async function fetchProjects() {
    const response = await axios.get(PROJECTS_API);
    return response.data;
}
